import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';

const year = new Date().getFullYear();

export default function HomeCta() {
  const monthly = dramas.filter((d) => d.updateDate.startsWith(String(year))).length;
  return (
    <section className="w-full px-4 md:px-10 py-12 md:py-16 bg-background-100/70">
      <div className="relative rounded-lg overflow-hidden bg-primary-950">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20of%20a%20dim%20empty%20theatre%20auditorium%20with%20deep%20burgundy%20velvet%20seats%20and%20faint%20warm%20amber%20stage%20light%2C%20atmospheric%20haze%20and%20heavy%20shadows%2C%20minimal%20composition%2C%20rich%20maroon%20palette%2C%20elegant%20moody%20texture&width=1600&height=520&seq=ethics-cta-01&orientation=landscape"
          alt="影视内容门户氛围图"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-primary-950/40"></div>
        <div className="relative z-10 px-6 md:px-12 py-10 md:py-14">
          <span className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.18em] uppercase text-accent-400 mb-3">
            <span className="w-4 h-px bg-accent-500"></span>
            Find Your Story
          </span>
          <h2 className="font-heading text-2xl md:text-[34px] leading-snug font-semibold text-background-50 max-w-2xl mb-3">
            不知道从哪一部开始？从一个关键词找起
          </h2>
          <p className="text-sm leading-7 text-background-200 max-w-xl mb-6">
            输入剧名、演员、导演或是你关心的主题词，我们会从站内演示数据中为你匹配相关剧集。本年度已更新 {monthly} 部作品资料。
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/search"
              className="h-11 md:h-12 px-6 rounded-md bg-accent-500 text-primary-950 text-sm font-medium flex items-center gap-2 whitespace-nowrap hover:bg-accent-400 transition-colors"
            >
              <i className="ri-search-line"></i>
              前往搜索
            </Link>
            <Link
              to="/category/classic"
              className="h-11 md:h-12 px-6 rounded-md border border-background-50/35 text-background-50 text-sm flex items-center gap-2 whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              经典佳作
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}